import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";
import axiosInstance from "src/store/features/auth/axiosCSRF";
export interface iGetSequenceState {
    response: any;
    message: string;
    isLoading: boolean;
    error: string | null;
}

const initialState: iGetSequenceState = {
    response: [],
    message: "",
    isLoading: false,
    error: null
}


export const getSequenceAPI = createAsyncThunk(
    "GET_SEQUENCE",
    async(params: {entryname: string}, {rejectWithValue}) => {
        try {
            const djangoEndpoint = getDjangoEndpoint();
            
            const pathParam = `/data/ppi-inhibitor/get-sequence/?entry_name=${encodeURIComponent(params.entryname)}`;
            const response = await axiosInstance.get(`${djangoEndpoint}${pathParam}`, {
                withCredentials: true,
            });
            
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

export const sequenceSlice = createSlice({
    name: "getSequenceList",
    initialState,
    reducers: {
        // Add a reset action to clear the state when needed
        resetSequenceData: (state) => {
            state.response = [];
            state.message = "";
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getSequenceAPI.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getSequenceAPI.fulfilled, (state, action) => {
                state.isLoading = false;
                state.response = action.payload; // Store the response data
                state.message = "success";
            })
            .addCase(getSequenceAPI.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload as string || "An error occurred";
                state.message = "error";
            });
    }
});

export const { resetSequenceData } = sequenceSlice.actions;
export default sequenceSlice.reducer;